import styled from 'styled-components';

export const tableBodyStyle = { fontSize: 14, padding: '15px 15px' };

export const TableWrapper = styled.div`
  overflow: auto;
`;

export const Wrapper = styled.div`
  padding: 45px 9px 0;
  padding-bottom: 0px;
`;

export const ModalWrapper = styled.div`
  padding: 10px 20px;
`;

export const Space = styled.div`
  margin-bottom: 15px;
`;
